import { ObserversModule } from '@angular/cdk/observers';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';

import { RippleHoverModule } from '@libs/src/ripple-hover/ripple-hover.module';

import { AccountChipComponent } from './account-chip/account-chip.component';
import { ChipComponent } from './chip.component';
import { TagChipComponent } from './tag-chip/tag-chip.component';

@NgModule({
  declarations: [AccountChipComponent, ChipComponent, TagChipComponent],
  exports: [AccountChipComponent, ChipComponent, TagChipComponent],
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    MatRippleModule,
    MatIconModule,
    NzToolTipModule,
    ObserversModule,
    RippleHoverModule,
  ],
})
export class ChipModule {}
